import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { QueueModule } from '®shared/container-structure/edit/queue';
import { ContainerStructureViewModule } from '®shared/container-structure/view';
import { CurrentUserModule } from '®shared/current-user';
import { DashboardAnalyticsModule } from '®shared/dashboard-analytics';
import { EventsModule } from '®shared/events';
import { FocusModule } from '®shared/focus';
import { GoogleAnalyticsGA4Module } from '®shared/google-analytics/google-analytics-ga4';
import { ReportBrokenLinkModalModule } from '®shared/list-item/report-broken-link-modal';
import { ShareSheetModule } from '®shared/list-item/share-sheet';
import { ListItemsModule } from '®shared/list-item/store';
import { CitationSwitcherModule } from '®shared/reading-list/citation-switcher';
import { EditModalsModule } from '®shared/reading-list/edit-modals';
import { NodesEditorModule } from '®shared/reading-list/hierarchy/editor';
import { ItemsFilterModule } from '®shared/reading-list/items-filter';
import { ListAlertsModule } from '®shared/reading-list/list-alerts';
import { ListDetailsModule } from '®shared/reading-list/list-details';
import { ListDetailsEditorModule } from '®shared/reading-list/list-details/editor';
import { ListOwnersModule } from '®shared/reading-list/list-owners';
import { ReadingListModule } from '®shared/reading-list/models';
import { OnlineResourceButtonsModule } from '®shared/reading-list/online-resource-buttons';
import { QuickFiltersMenuModule } from '®shared/reading-list/quick-filters';
import { ResourceTypeFiltersMenuModule } from '®shared/reading-list/resource-type-filter';
import { StickyFooterBarModule } from '®shared/reading-list/sticky-footer-bar';
import { TableOfContentsModule } from '®shared/reading-list/table-of-contents';
import { ViewListAsStudentModule } from '®shared/reading-list/view-list-as-student';
import { RequestReviewModule } from '®shared/reviews/request-review';
import { ReviewHistoryModule } from '®shared/reviews/review-history';
import { TenantModule } from '®shared/tenant';
import { UriModule } from '®shared/url-utils';
import { UserModule } from '®shared/user';
import { UserSubscribedListsModule } from '®shared/user/subscribed-lists';
import { UserAnnotationsModule } from '®shared/user-annotations';

import { LtiAlertModule } from '../../../lti/lti-alert';
import { CurrentListResolverModule } from '../resolver';

import { ListViewRoutingModule } from './list-view-routing.module';
import { ListViewComponent } from './list-view.component';

@NgModule({
  imports: [
    CitationSwitcherModule,
    CommonModule,
    ContainerStructureViewModule,
    CurrentListResolverModule,
    CurrentUserModule,
    DashboardAnalyticsModule,
    EditModalsModule,
    EventsModule,
    FocusModule,
    GoogleAnalyticsGA4Module,
    ItemsFilterModule,
    ListAlertsModule,
    ListDetailsModule,
    ListDetailsEditorModule,
    ListItemsModule,
    ListOwnersModule,
    ListViewRoutingModule,
    LtiAlertModule,
    NodesEditorModule,
    OnlineResourceButtonsModule,
    QueueModule,
    QuickFiltersMenuModule,
    ResourceTypeFiltersMenuModule,
    ReadingListModule,
    ReportBrokenLinkModalModule,
    RequestReviewModule,
    ReviewHistoryModule,
    ShareSheetModule,
    StickyFooterBarModule,
    ViewListAsStudentModule,
    TableOfContentsModule,
    TenantModule,
    UriModule,
    UserAnnotationsModule,
    UserModule,
    UserSubscribedListsModule,
  ],
  declarations: [ListViewComponent],
  exports: [ListViewComponent],
})
export class ListViewModule {}
